import { useCallback } from 'react';
import { Sizes } from 'enums/sizes';
import { useDialog } from 'hooks/useDialog';
import { useAbp } from 'core/hooks/useAbp';
import { AbpPolicies } from 'core/constants/AbpPolicies';
import { CreateTunnelModal } from './CreateTunnelModal';

/**
 * Ouverture du formulaire de création, depuis le bouton d'en-tête de la liste admin.
 * La permission est BackOffice.Tunnels.Create — celle du groupe Tunnels, et non de
 * AdminTunnels qui ne couvre que la liste, la duplication et la suppression.
 */
export const useCreateTunnelDialog = () => {
  const { openBlankDialog } = useDialog();
  const { hasPermission } = useAbp();

  const canCreate = hasPermission(AbpPolicies.TUNNELS_CREATE);

  const openCreateDialog = useCallback(
    (onCreated?: () => void) =>
      openBlankDialog({ size: Sizes['3xl'] }, <CreateTunnelModal onCreated={onCreated} />),
    [openBlankDialog]
  );

  return { canCreate, openCreateDialog };
};
